<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="600px"
    @close="$router.replace('/data/services/services')"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      :model="service"
      :rules="rules"
      ref="serviceForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="store"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="name"
            label="Név"
          >
            <el-input
              v-model="service.name"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="status"
            label="Státusz"
          >
            <el-select
              v-model="service.status"
              style="width: 100%;"
            >
              <el-option :value="'active'" label="Aktív">Aktív</el-option>
              <el-option :value="'inactive'" label="Inaktív">Inaktív</el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="category_id"
            label="Kategória"
          >
            <el-select
              v-model="service.category_id"
              style="width: 100%;"
            >
              <el-option
                v-for="category in categories"
                :label="category.name"
                :value="category.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="vat_id"
            label="Áfa"
          >
            <el-select
              v-model="service.vat_id"
              style="width: 100%;"
            >
              <el-option
                v-for="vat in vats"
                :label="vat.value + '%'"
                :value="vat.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="gla_number_id"
            label="Főkönyvi szám"
          >
            <el-select
              v-model="service.gla_number_id"
              style="width: 100%;"
              filterable
            >
              <el-option
                v-for="glaNumber in glaNumbers"
                :label="glaNumber.value"
                :value="glaNumber.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Mennyiségi egység"
            prop="quantity_unit"
          >
            <el-select
              v-model="service.quantity_unit"
              style="width: 100%;"
            >
              <el-option
                v-for="unit in measureUnits"
                :key="unit.value"
                :value="unit.value"
                :label="unit.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Nettó ár"
            prop="price"
          >
            <el-input-localized-numeric
              v-model="service.price"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Szj szám"
            prop="registration_number"
          >
            <el-input
              v-model="service.registration_number"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-switch
        v-model="service.accountant_export"
        active-text="Könyvelésben szerepel"
        style="margin-bottom: 20px;"
      />
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Könyvelés követel szám"
            prop="accountant_claim_code"
          >
            <el-input
              v-model="service.accountant_claim_code"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Könyvelés megjegyzés"
            prop="accountant_comment"
          >
            <el-input
              v-model="service.accountant_comment"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/data/services/services')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="store"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import measureUnits from '../../../utils/measureUnits';

export default {
  props: ['type', 'serviceId'],
  data() {
    return {
      measureUnits,
      loading: false,
      buttonLoading: false,
      remoteLoading: false,
      service: {},
      rules: {
        name: [
          {
            required: true,
            message: 'Név megadása kötelező',
            trigger: 'change'
          }
        ],
      },
    };
  },
  computed: {
    glaNumbers() {
      return this.$store.getters['glaNumber/glaNumbers'];
    },
    vats() {
      return this.$store.getters['vat/vats'];
    },
    categories() {
      return this.$store.getters['serviceCategory/serviceCategories'];
    },
    title() {
      if (this.type === 'add') {
        return 'Új szolgáltatás';
      } else if (this.type === 'update') {
        return 'Szolgáltatás módosítása';
      } else {
        return '';
      }
    },
    buttonText() {
      if (this.type === 'add') {
        return 'Hozzáadása';
      } else if (this.type === 'update') {
        return 'Módosítás';
      } else {
        return '';
      }
    },
  },
  methods: {
    handleClose() {
      this.$confirm('Biztosan elveted a módosításokat?', {
        confirmButtonText: 'Igen',
        type: 'warning',
      })
        .then(() => {
          this.$router.replace('/data/services/services');
        })
        .catch(() => {
        });
    },
    async store() {
      this.$refs['serviceForm'].validate(async valid => {
        if (valid) {
          this.buttonLoading = true;
          try {
            if (this.type === 'add') {
              await this.$store.dispatch('service/create', this.service);
            } else if (this.type === 'update') {
              await this.$store.dispatch('service/update', this.service);
            }
            this.$store.dispatch('service/fetchAll');
            this.buttonLoading = false;
            this.$router.replace('/data/services/services');
          } catch (e) {
          }
          this.buttonLoading = false;
        }
      });
    },
  },
  async mounted() {
    this.loading = true;
    await Promise.all([
      this.$store.dispatch('serviceCategory/fetchAll'),
      this.$store.dispatch('vat/fetchAll'),
      this.$store.dispatch('glaNumber/fetchAll'),
    ]);
    if (this.serviceId) {
      this.service = await this.$store.dispatch('service/fetch', this.serviceId);
    }
    this.loading = false;
  },
};
</script>
